const features = [
  {
    icon: 'ri-shield-star-line',
    title: '永久免费',
    desc: '无需注册、无需会员、无需付费，打开网站即可畅享海量高清影视资源。我们承诺永不收费，让观影回归最简单的快乐。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清不缓冲',
    desc: '多线CDN全球加速配合智能码率自适应技术，无论在电脑还是手机上都能享受流畅高清的观影体验，告别卡顿等待。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源库',
    desc: '超过两万部影视资源每日更新，涵盖电影、电视剧、综艺、动画、纪录片等全品类，你想看的这里几乎都能找到。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '全面适配电脑、平板和手机，无需下载APP，浏览器即开即看。移动端支持全屏播放、倍速调节和播放进度记忆。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          为什么选择桃花影院？四大优势告诉你答案
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 text-center hover:border-primary-300 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mx-auto mb-4">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}